// Helper to determine MFA type from value
const getMFATypeFromValue = (value) => {
  return /@/.test(value) ? 'EMAIL' : 'SMS';
};

// Extract MFA options from ForgeRock callbacks
// Returns array of {type: 'SMS'|'EMAIL', value: '*** *** 1234'}
export const getMFAOptionsFromCallbacks = (callbacks) => {
  const choiceCallback = callbacks.find(
    callback => callback.type === 'ChoiceCallback'
  );
  
  if (!choiceCallback) return [];
  
  const choicesOutput = choiceCallback.output.find(output => output.name === 'choices');
  
  if (!choicesOutput || !Array.isArray(choicesOutput.value)) return [];
  
  return choicesOutput.value.map(option => ({
    type: getMFATypeFromValue(option),
    value: option,
  }));
};
